import { useEffect, useState } from "react";
import { NatalChartResultDto } from "../../../api";
import { AspectUI, ChartData, natalChartToUI } from "../adapters/natalChartToAstroChart";

export function useNatalChart(fetcher: () => Promise<NatalChartResultDto>) {
  const [chartData, setChartData] = useState<ChartData | null>(null);
  const [aspects, setAspects] = useState<AspectUI[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetcher();
        if (cancelled || !res) return;

        const mapped = natalChartToUI(res);
        setChartData(mapped.chartData);
        setAspects(mapped.aspects);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [fetcher]);

  return { chartData, aspects, loading, error };
}
